import {
  AUDIO_TRANSCRIPTION_DEFAULT_PROMPT,
  AUDIO_TRANSCRIPTION_ONBOARDING_STORAGE_KEY_PREFIX,
} from '@shared/constants/audio-transcription';
import type { ChatSessionIntent } from './chat-session-intent';

export const AUDIO_TRANSCRIPTION_QUICK_ACTION_LABEL = 'Transcrire des fichiers audio';

export function getAudioTranscriptionOnboardingStorageKey(userId: string) {
  return `${AUDIO_TRANSCRIPTION_ONBOARDING_STORAGE_KEY_PREFIX}${userId}`;
}

export function hasSeenAudioTranscriptionOnboarding(userId: string | undefined) {
  if (!userId || typeof window === 'undefined') {
    return false;
  }

  try {
    return window.localStorage.getItem(getAudioTranscriptionOnboardingStorageKey(userId)) === '1';
  } catch {
    return false;
  }
}

export function markAudioTranscriptionOnboardingSeen(userId: string | undefined) {
  if (!userId || typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.setItem(getAudioTranscriptionOnboardingStorageKey(userId), '1');
  } catch {
    // Private mode / quota: the modal may reappear, which is acceptable.
  }
}

export function applyAudioTranscriptionPrompt(currentDraft: string) {
  return currentDraft.trim().length === 0 ? AUDIO_TRANSCRIPTION_DEFAULT_PROMPT : currentDraft;
}

export function shouldShowAudioTranscriptionQuickAction(input: {
  conversationId?: string;
  enabled?: boolean;
  hasMessages: boolean;
  intent: ChatSessionIntent;
}) {
  return input.enabled === true
    && !input.conversationId
    && !input.hasMessages
    && input.intent === 'general';
}

export type AudioTranscriptionQuickActionResult =
  | { nextInput: string; type: 'open-onboarding' }
  | { nextInput: string; type: 'open-picker' };

export function resolveAudioTranscriptionQuickAction(input: {
  currentInput: string;
  hasSeenOnboarding: boolean;
}): AudioTranscriptionQuickActionResult {
  const nextInput = applyAudioTranscriptionPrompt(input.currentInput);

  if (input.hasSeenOnboarding) {
    return { nextInput, type: 'open-picker' };
  }

  return { nextInput, type: 'open-onboarding' };
}
